import { Exception } from '../Exception';
export class OutlookItemNotSupported extends Exception {
  constructor() {
    super();
  }
}
